import { Config } from '@leverege/plugin'

export default {
  id : 'ps.action.OpenEventStartImageUrl',
  matches : {
    client : 'LinearViewBlock'
  },
  layout : {
    group : [ 'Image', 'Start' ],
    groupIcons : [ 'fa fa-fw fa-camera' ]
  },
  appearance : () => ( {
    name : 'Open',
    icon : 'fa fa-fw fa-external-link'
  } ),
  handles : ( context ) => {
    const { item } = context
    
    return item?.startData != null
  },
  perform : ( { context } ) => {
    const { item } = context
    const imageBucketUrl = Config.get( 'LinearViewBlock', 'gcsImageBucketUrl' )
    window.open( `${imageBucketUrl}/${item.startData.imagePath}`, '_blank' ).focus()
  }
}
